import { Button } from '@material-ui/core';
import React, { ReactNode } from 'react';

export interface PrimaryButtonProps {
  'data-test'?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
  title: ReactNode;
  onClick?: () => void | Promise<void>;
  disabled?: boolean;
  submit?: boolean;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  title,
  className,
  onClick,
  disabled,
  submit,
  startIcon,
  endIcon,
  'data-test': dataTest,
}) => (
  <Button
    data-test={dataTest}
    startIcon={startIcon}
    endIcon={endIcon}
    className={className}
    variant="outlined"
    color="primary"
    onClick={onClick}
    disabled={disabled}
    {...(submit ? { type: 'submit' } : {})}
  >
    {title}
  </Button>
);

export default PrimaryButton;
